<template>
    <!--气体-->
    <div class="gas">
        <div class="title">
            <div class="title-text">设备气体监测</div>
        </div>
        <div class="temper-box">
            <div class="temper-list">
                <div class="temper-top">
                    <div class="">设备编号</div>
                    <div class="">设备名称</div>
                    <div class="">气体检测</div>

                </div>
                <div class="temper-bottom">
                    <div class="temper-bottom-info">
                        <div class="round"></div>
                        <span>AK0213</span>
                        <span>气罐</span>
                        <span>正常</span>
                        <div class="temper-bottom-info-bg"></div>
                    </div>
                </div>
            </div>
            <div class="temper-list">
                <div class="temper-bottom">
                    <div class="temper-bottom-info active">
                        <div class="round"></div>
                        <span>AK0214</span>
                        <span>气罐</span>
                        <span>正常</span>
                        <div class="temper-bottom-info-bg"></div>
                    </div>
                </div>
            </div>
            <div class="temper-list">
                <div class="temper-bottom">
                    <div class="temper-bottom-info">
                        <div class="round"></div>
                        <span>AK0215</span>
                        <span>气罐</span>
                        <span>正常</span>
                        <div class="temper-bottom-info-bg"></div>
                    </div>
                </div>
            </div>
            <div class="temper-list">
                <div class="temper-bottom">
                    <div class="temper-bottom-info">
                        <div class="round"></div>
                        <span>AK0216</span>
                        <span>气罐</span>
                        <span>正常</span>
                        <div class="temper-bottom-info-bg"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "gas"
    }
</script>

<style scoped lang="less">

    .gas {
        font-family: sy;
        width: 90%;

        font-size: 12px;
        color: white;

        .temper-list {
            margin-top: 0px;
            .temper-top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 3px 10px;
                box-sizing: border-box;
                margin-top: 5%;
                background: url('./../../assets/img/topbox.png');
                background-size: 100% 100%;
            }

            .temper-bottom {
                .temper-bottom-info {
                    position: relative;
                    padding: 9px 10px;
                    padding-right: 25px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    &.active{
                        .round{
                            background: #ff9600;
                        }
                        color: #ff9600;
                    }
                    .round {
                        position: absolute;
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        top: 50%;
                        left: 0;
                        background: #98fef9;
                    }
                    .temper-bottom-info-bg {
                        position: absolute;
                        bottom: 0;
                        width: 98%;
                        height: 2px;
                        left: 0;
                        background: url("./../../assets/img/list.png") no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }
    }
</style>